import captureSentryException from '@/features/app/functions/captureSentryException';
import type NotificationSetting from '@/features/user/types/notification-setting';
import useAxios from '@/shared/hooks/useAxios';

export default function useNotificationSettingsQueryOptions() {
  const axios = useAxios();

  return {
    queryKey: ['notificationSettings'],
    async queryFn() {
      return axios
        .get('/api/v1/user/notification-settings')
        .then((res) => res.data.userNotificationSettings as NotificationSetting[])
        .catch((error) => {
          captureSentryException(error);
          return Promise.reject(error);
        });
    },
  };
}
